import { normalizeForUpload } from "./media_normalizer.mjs";

let Uploaders = {};

Uploaders.S3 = function (entries, onViewError) {
    entries.forEach((entry) => {
        let formData = new FormData();
        let { url, fields, max_file_size } = entry.meta;
        Object.entries(fields).forEach(([key, val]) => formData.append(key, val));

        let xhr = new XMLHttpRequest();
        let cancelled = false;

        // The request is not opened in this tick any more -- it waits on the
        // normalisation below -- and aborting an XHR that was never opened does
        // nothing. The flag is what catches a cancel landing in that window; abort()
        // still stops one already in flight.
        onViewError(() => {
            cancelled = true;
            xhr.abort();
        });

        xhr.onload = () => (xhr.status === 204 ? entry.progress(100) : entry.error());
        xhr.onerror = () => entry.error();
        xhr.upload.addEventListener("progress", (event) => {
            if (event.lengthComputable) {
                let percent = Math.round((event.loaded / event.total) * 100);
                if (percent < 100) {
                    entry.progress(percent);
                }
            }
        });

        let send = (file) => {
            if (cancelled) return;

            formData.append("file", file);
            xhr.open("POST", url, true);
            xhr.send(formData);
        };

        // A photo is turned upright and stripped of its metadata here rather than
        // after it lands, because the CDN caches a rendition for a year the first
        // time it is asked for one. See media_normalizer.mjs.
        //
        // normalizeForUpload swallows its own failures and hands back the original, so
        // the rejection arm should be unreachable; it is here because if that ever
        // stops being true the entry would otherwise sit at its last percentage
        // forever, with neither progress(100) nor error() to end it.
        normalizeForUpload(entry.file, max_file_size).then(send, () => send(entry.file));
    });
};

export default Uploaders;
